import React, { useEffect } from 'react'
import TabComponent from '../../component/TabComponent'
import Reserve from './reserve'
import ReserveHq from './reserveHq'
import { StockProvider } from './services/stockApi'
import StockAdjust from './stockAdjust'
import StockBalance from './stockBalance'
import StockReceive from './stockReceive'
import StockTransfer from './stockTransfer'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

export default function Stock() {
    const { profile } = useSelector(state => state.profile)
    const location = useLocation()
    const navigate = useNavigate()
    const dataTabs = [
        {
            title: 'เมล็ดพันธุ์คงคลัง',
            page: <StockBalance />,
            url: '/stock/balance',
            Permit: profile?.Permissions?.find((x) => x?.Action === 'Balance.Read')?.Permit
        },
        {
            title: 'รับเมล็ดพันธุ์',
            page: <StockReceive />,
            url: '/stock/stock-receive',
            Permit: profile?.Permissions?.find((x) => x?.Action === 'Receive.Read')?.Permit
        },
        {
            title: 'โอนเมล็ดพันธุ์',
            page: <StockTransfer />,
            url: '/stock/stock-transfer',
            Permit: profile?.Permissions?.find((x) => x?.Action === 'Transfer.Create')?.Permit
        },
        {
            title: 'สำรองเมล็ดพันธุ์ (ศูนย์)',
            page: <Reserve />,
            url: '/stock/reserve',
            Permit: profile?.Permissions?.find((x) => x?.Action === 'Reserve.Read')?.Permit
        },
        {
            title: 'สำรองเมล็ดพันธุ์ (ส่วนกลาง)',
            page: <ReserveHq />,
            url: '/stock/reserve-hq',
            Permit: profile?.Permissions?.find((x) => x?.Action === 'Reserve.Read')?.Permit
        },
        {
            title: 'ปรับปรุงยอด',
            page: <StockAdjust />,
            url: '/stock/stock-adjust',
            Permit: profile?.Permissions?.find((x) => x?.Action === 'Adjust.Read')?.Permit
        },
    ]
    // useEffect(() => {
    //     if (location.pathname === '/stock') {
    //         navigate(dataTabs[0].url)
    //     }
    // }, [location.pathname])
    return (
        <div style={{ padding: '10px 30px' }}>
            <StockProvider>
                <TabComponent dataTabs={dataTabs} />
            </StockProvider>
        </div>
    )
}
